import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import template from './EnsembleMemberEditor.html?raw';
import { AddressWizardTypes as Types } from "../../../AddressWizardTypes";

import _StatefulSection from '../../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../../../../moreCore/UI/Container/uiFrame';

class EnsembleMemberEditor extends compose(_StatefulSection, _uiFrameMixin) {
    templateString: any = template;

    setup(entity: Types.EnsembleMember, title: string) {
        this.setData(entity);

        //this.createDefaultButton("ok", lang.hitch(this, this.onClick_OK), true, "secondary");
        this.addButton("okBtn", this.translate("General_Label_BtnOk"), lang.hitch(this, this.onClick_OK), null, "accentBG", null, true, "primary");
        this.show("dlg", title);
        this._uiFrameDlg._setCloseBtnAttr(false, false); //removeButton() funktioniert hier nicht
    }

    private onClick_OK() {
        this.emit("okClicked", this.changedData);
        this.close();
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EnsembleMemberEditor);